// extracted by mini-css-extract-plugin
export default {"shell":"SafeAreaView_shell__20yLP"};